import _ from "lodash";
import appManager from "../managers/app";
import datetimeManager from "../managers/datetime";
import envManager from "../managers/env";
import { GRANULARITIES, GRANULARITY_DAY, CHART_CTT, CHART_SPREAD, CHART_BID_ASK_QUANTITY, SELECT_EMPTY_VALUE, ZONES } from "../managers/constants";
import { MSG_ERR_SERVER_GENERIC } from "../managers/string-literals";

const service = (() => {
  // Convert object to query string
  // Ref: https://stackoverflow.com/questions/1714786/query-string-encoding-of-a-javascript-object
  const convertObjectToQueryString = (obj = {}) =>
    Object.keys(obj)
      .reduce(function(a, k) {
        a.push(k + "=" + encodeURIComponent(obj[k]));
        return a;
      }, [])
      .join("&");

  // Construct HTTP query string to be sent to API to fetch App data
  const constructAppDataHttpQueryString = () =>
    convertObjectToQueryString({
      uId: appManager.getUserId()
    });

  // Construct HTTP query string to be sent to API to fetch Chart data
  const constructChartDataHttpQueryString = (state, whiteboardIndex) => {
    let requestObj = {};
    let zoneObj = _.find(ZONES, { Code: state.selectedZone });
    let whiteboard = state.chartWhiteboards[whiteboardIndex];

    requestObj.uId = appManager.getUserId();
    requestObj.prd = state.selectedProduct;

    let dayGranularityIndex = _.findIndex(GRANULARITIES, { Code: GRANULARITY_DAY });
    let selectedGranularityIndex = _.findIndex(GRANULARITIES, { Code: whiteboard.selectedGranularity });
    requestObj.gran = selectedGranularityIndex <= dayGranularityIndex ? whiteboard.selectedGranularity : GRANULARITY_DAY;

    requestObj.trdngHrs = state.selectedTradingHour;
    requestObj.tz = state.selectedZone;

    // Convert selected Start/End Date with respect to selected Zone Offset
    // Start Date to early morning
    // Ex. Start Date : "Mar 10, 2018" (Chicago) ==> "Sat Mar 10 2018 00:00:00 GMT-0600"
    // End Date to late night
    // Ex. End Date : "Mar 29, 2018" (Chicago) ==> "Thu Mar 29 2018 23:59:59 GMT-0600"
    requestObj.frmTS = datetimeManager.getEarlyMorning(state.selectedDateRangeFrom, zoneObj.Offset).unix();
    requestObj.toTS = datetimeManager.getLateNight(state.selectedDateRangeTo, zoneObj.Offset).unix();

    // Send Lot Sizes for Cost To Trade
    if (whiteboard.selectedPrimaryChart === CHART_CTT || whiteboard.selectedComparisonChart === CHART_CTT) {
      requestObj.cttLots = whiteboard.selectedCostToTradeLotSizes.join();
    }

    // Fetch only Top Of The Book for overlay comparison
    if (whiteboard.selectedComparisonChart && whiteboard.selectedComparisonChart !== SELECT_EMPTY_VALUE) {
      requestObj.tob = true;
    }

    return convertObjectToQueryString(requestObj);
  };

  // Get API endpoint for App data
  const getAppDataEnpoint = () => {
    //return envManager.getApiBaseUrl() + envManager.getApiEndpointProduct();
    return envManager.getApiBaseProductUrl() + envManager.getApiEndpointProduct();
  };

  // Get applicable API endpoint based on chart
  const getApplicableChartDataEnpoint = (whichChart) => {
    if (whichChart === CHART_CTT) {
      return envManager.getApiBaseUrl() + envManager.getApiEndpointCostToTrade();
    } else if (whichChart === CHART_SPREAD) {
      return envManager.getApiBaseUrl() + envManager.getApiEndpointSpread();
    } else if (whichChart === CHART_BID_ASK_QUANTITY) {
      return envManager.getApiBaseUrl() + envManager.getApiEndpointBidAskQuantity();
    }
  };

  const getFeedbackSubmissionEnpoint = () => envManager.getApiBaseUrl() + envManager.getApiEndpointFeedback();

  const getHelpDataEnpoint = () => envManager.getAppBaseUrl() + envManager.getApiEndpointHelp();

  const getHistoricalDataLink = () => envManager.getBuyHistoricalDataLink();

  const transfigureAPIErrorMessages = (error) => {
    return error && error.response && error.response.data && error.response.data.errorMessage && error.response.data.errorMessage.trim().length
      ? error.response.data.errorMessage.replace("|", "<br>")
      : MSG_ERR_SERVER_GENERIC;
  };

  return {
    convertObjectToQueryString,
    constructAppDataHttpQueryString,
    constructChartDataHttpQueryString,
    getAppDataEnpoint,
    getApplicableChartDataEnpoint,
    getFeedbackSubmissionEnpoint,
    getHelpDataEnpoint,
    getHistoricalDataLink,
    transfigureAPIErrorMessages
  };
})();

export default service;



// WEBPACK FOOTER //
// ./src/services/managers/http.js